import React from "react";

import { getDamPath } from "@utils/configuration/aem";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { useLanguage } from "@context/language.context";

const FAVVCODE_DOCUMENT_PREFIX = "PES";

type FavvCodeProps = {
    code?: string | null;
};

const FavvCode = ({ code }: FavvCodeProps) => {
    const { t } = useGranite();
    const { getLocale } = useLanguage();

    const displayFavvDocument =
        !!code && code.startsWith(FAVVCODE_DOCUMENT_PREFIX);

    return (
        <section className="feature-list-component mb-3">
            <div className="col-12 border-bottom border-primary">
                <div className="py-2 font-weight-bold">
                    {t("productDetail.featureList.favvCode.title")}
                </div>
            </div>

            <div className="feature-list-component__list">
                <div className="col-12 feature-list-component__item">
                    <div className="row border-bottom ">
                        <div className="col-6 feature-list-component__item--gray">
                            <div className="py-2">
                                {t(
                                    "productDetail.featureList.favvCode.number.label",
                                )}
                            </div>
                        </div>
                        <div className="col-6 bg-light">
                            <div className="py-2">{code}</div>
                        </div>
                    </div>
                </div>
                {displayFavvDocument && (
                    <div className="col-12 feature-list-component__item">
                        <div className="row border-bottom ">
                            <div className="col-6 feature-list-component__item--gray">
                                <div className="py-2">
                                    {t(
                                        "productDetail.featureList.favvCode.image.label",
                                    )}
                                </div>
                            </div>
                            <div className="col-6 bg-light">
                                <div className="py-2">
                                    <a
                                        href={`${getDamPath()}/product-detail-page/favv/${getLocale(
                                            true,
                                        )}/document.pdf`}
                                        target="_blank"
                                    >
                                        <img
                                            src={`${getDamPath()}/product-detail-page/favv/gewasbescherming.png`}
                                            alt={t(
                                                "productDetail.featureList.favvCode.image.alt",
                                            )}
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export { FavvCode };
